import { render } from "./ChatRecipeTitle.vue?vue&type=template&id=12e7df7b&scoped=true"
import script from "./ChatRecipeTitle.vue?vue&type=script&lang=js"
export * from "./ChatRecipeTitle.vue?vue&type=script&lang=js"

import "./ChatRecipeTitle.vue?vue&type=style&index=0&id=12e7df7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e7df7b"]])

export default __exports__